export default __webpack_public_path__ + "static/media/sbilife-logo.732f519e.png";